import api from "./api";
import { catchValidationErrors } from "./catchErrors";

class DashboardService {
    async getInfos() {
        const { data } = await api.get("/api/dashboard").catch(catchValidationErrors);

        return data;
    }

    async getNewLoyers(page) {
        const { data } = await api.get(`/api/dashboard/new-loyers?page=${page}&limit=10`).catch(catchValidationErrors);

        return data;
    }

    async getGlobalStatistiques(includeArchived = false) {
        const { data } = await api.get(`/api/dashboard/statistiques?includeArchived=${includeArchived ? 1 : 0}`).catch(catchValidationErrors);

        return data;
    }
}

export default new DashboardService();